module.exports = __webpack_public_path__ + "img/filters2.ce36bcb9.svg";